import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
	AlertBox,
	RadioGroup,
	SelectInput,
	TextInput,
} from "@life-line-lab/components-react";
import { isNil, isUndefined } from "lodash";
// ANTD
import { Col, Row } from "antd";
import { fetchDiolkoCompaniesList } from "Services/driver-management.service";
import useSession from "Hooks/session.hook";

const VehicleInfo = ({
	input,
	setInput,
	error,
	handleFieldChange,
	handleRadioChange,
	handleSelectChange,
	isExternalCreation,
}) => {
	const { t } = useTranslation();
	const { org } = useSession();
	const [diolkoCompaniesOpt, setDiolkoCompaniesOpt] = useState<any>([]);
	const [orgList, setOrgList] = useState<any>();

	useEffect(() => {
		handleFetchDiolkoCompanies();
	}, []);

	useEffect(() => {
		if (input.doesRiderOwnVehicle == "false") {
			setInput({
				...input,
				vehicleCategory: null,
				vehicleType: null,
				vehicleModel: null,
				plateNumber: null,
			});
		}
	}, [input.doesRiderOwnVehicle]);

	const handleFetchDiolkoCompanies = async () => {
		const response = await fetchDiolkoCompaniesList(org.logisticProviderOrgID);
		if (!isNil(response)) {
			const orgList = response.orgs;
			if (orgList) setOrgList(orgList);
			const orgOptions = orgList.map((org) => {
				return {
					value: org.orgID,
					label: org.orgName,
				};
			});
			if (isExternalCreation) setDiolkoCompaniesOpt(orgOptions);
			else
				setDiolkoCompaniesOpt([
					{
						value: org._id,
						label: org.name,
					},
				]);
		}
	};

	return (
		<React.Fragment>
			{input._id ? null : (
				<div className="center header-title">
					{t("title.vehicleInformation").toUpperCase()}
				</div>
			)}
			<Row gutter={[15, 15]} className="mt-50">
				<Col xs={24} sm={24} md={12}>
					<SelectInput
						showSearch
						options={diolkoCompaniesOpt}
						filterOption={(inputValue, option) =>
							option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
						}
						value={input.parentOrgID}
						name="parentOrgID"
						label={t("label.parentOrgID")}
						placeholder={t("option.parentOrgID")}
						isRequired={true}
						isReadonly={input._id ? true : false}
						onChange={(value: string | string[]) =>
							handleSelectChange(value, "parentOrgID")
						}
					/>
					<AlertBox text={error.parentOrgID} />
				</Col>
				{/* ! Not needed, as every rider belongs to Diolko */}
				{/* <Col xs={24} sm={24} md={12}>
                    <div className="required-div">
                        <span className="required-mark">*</span>
                        <RadioGroup
                            options={[
                                { key: "individual", label: t("label.individual").toUpperCase(), value: "INDIVIDUAL" },
                                { key: "supplier", label: t("label.supplier"), value: "COMPANY" },
                            ]}
                            direction="horizontal"
                            name='riderType'
                            value={input.riderType}
                            isRequired={true}
                        />
                    </div>
                    <SelectInput
                        options={[]}
                        value={input.companyID}
                        name="companyID"
                        placeholder={t('option.supplier')}
                        onChange={
                            (value: string | string[]) =>
                            handleSelectChange(value, 'companyID')
                        }
                    />
                    <AlertBox text={error.companyID} />
                </Col> */}
				<Col xs={24} sm={24} md={12}>
					<RadioGroup
						options={[
							{ key: "yes", label: t("label.yes"), value: "true" },
							{ key: "no", label: t("label.No"), value: "false" },
						]}
						direction="horizontal"
						label={t("label.doYouOwnVehicle")}
						isRequired={true}
						name="doesRiderOwnVehicle"
						value={input.doesRiderOwnVehicle}
						onChange={handleRadioChange}
					/>
					<AlertBox text={error.doesRiderOwnVehicle} />
				</Col>
				<Col xs={24} sm={24} md={12}>
					<Row>
						{/* <span className="required-mark">*</span> */}
						<Col span={1} className="mb-0">
							<span className="inp-label inp-label--required" />
						</Col>
						<Col span={23} className="mb-0">
							<RadioGroup
								options={[
									{
										key: "electricVehicle",
										label: t("label.electricVehicle"),
										value: "ELECTRIC",
									},
									{
										key: "normalVehicle",
										label: t("label.normalVehicle"),
										value: "NORMAL",
									},
								]}
								// label={t("label.vehicleCategory")}
								name="vehicleCategory"
								defaultChecked={
									input.doesRiderOwnVehicle == "true" ? "NORMAL" : null
								}
								value={input.vehicleCategory}
								defaultValue="NORMAL"
								onChange={handleRadioChange}
								direction="horizontal"
								isRequired={input.doesRiderOwnVehicle == "true" ? true : false}
								isReadonly={input.doesRiderOwnVehicle == "true" ? false : true}
							/>
							<AlertBox text={error.vehicleCategory} />
						</Col>
					</Row>
					<SelectInput
						showSearch
						options={[
							{ label: t("label.car"), value: "CAR" },
							{ label: t("label.van"), value: "VAN" },
							{ label: t("label.lorry"), value: "LORRY" },
							{ label: t("label.motorcycle"), value: "MOTORCYCLE" },
						]}
						filterOption={(inputValue, option) =>
							option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
						}
						value={input.vehicleType}
						name="vehicleType"
						placeholder={t("option.vehicleType")}
						onChange={(value: string | string[]) =>
							handleSelectChange(value, "vehicleType")
						}
						isRequired={input.doesRiderOwnVehicle == "true" ? true : false}
						isReadonly={input.doesRiderOwnVehicle == "true" ? false : true}
					/>
					<AlertBox text={error.vehicleType} />
				</Col>
				<Col xs={24} sm={24} md={12}>
					<TextInput
						placeholder={t("txt.vehicleModel")}
						value={input.vehicleModel}
						label={t("label.vehicleModel")}
						name="vehicleModel"
						onChange={handleFieldChange}
						isRequired={input.doesRiderOwnVehicle == "true" ? true : false}
						isReadonly={input.doesRiderOwnVehicle == "true" ? false : true}
					/>
					<AlertBox text={error.vehicleModel} />
				</Col>
				<Col xs={24} sm={24} md={12}>
					<TextInput
						label={t("label.plateNumber")}
						placeholder={t("txt.plateNumber")}
						value={input.plateNumber}
						name="plateNumber"
						onChange={handleFieldChange}
						isRequired={input.doesRiderOwnVehicle == "true" ? true : false}
						isReadonly={input.doesRiderOwnVehicle == "true" ? false : true}
					/>
					<AlertBox text={error.plateNumber} />
				</Col>
			</Row>
		</React.Fragment>
	);
};

export default VehicleInfo;
